import { useState, useEffect, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { caseFuneralHomeAtom } from 'atoms'
import formatDate from 'utils/dates/formatDate'
import { Case } from 'types/case'
import { getFuneralHomeById } from '@/api/funeralHomes'

export const useCaseInfo = (caseInfo: Case) => {
  const [caseHeader, setCaseHeader] = useState('')
  const setCasesFuneralHome = useSetRecoilState(caseFuneralHomeAtom)
  const location = useLocation()
  const funeralHomeId = caseInfo?.funeral_home_id

  const setUpCaseHeader = useCallback((caseInfo: Case) => {
    const caseHasANameOfDeceased = caseInfo?.name_of_deceased
    if (caseHasANameOfDeceased) {
      // Build header parts using array filtering for smart comma placement
      const headerParts = [caseInfo.name_of_deceased]
      const secondaryInfo =
        caseInfo?.editable_case_id ||
        formatDate(caseInfo?.date_of_death || '', 'PP')

      if (secondaryInfo) {
        headerParts.push(secondaryInfo)
      }

      setCaseHeader(headerParts.join(', '))
    } else {
      setCaseHeader('')
    }
  }, [])

  const setCaseFuneralHome = useCallback(
    async (funeralHomeId: string | null | undefined) => {
      if (funeralHomeId) {
        try {
          const { data: funeralHomeDetails = {} } =
            await getFuneralHomeById(funeralHomeId)
          setCasesFuneralHome(funeralHomeDetails)
        } catch (error) {
          console.error('Failed to fetch funeral home details:', error)
          setCasesFuneralHome({})
        }
      } else {
        setCasesFuneralHome({})
      }
    },
    [setCasesFuneralHome],
  )

  useEffect(() => {
    setUpCaseHeader(caseInfo)
  }, [caseInfo, setUpCaseHeader])

  useEffect(() => {
    setCaseFuneralHome(funeralHomeId)
  }, [funeralHomeId, location.key, setCaseFuneralHome])

  return { caseHeader }
}
